import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Constants from '../../config/constants';
import { COLUMN_STYLE, getColumnStyle } from '../../components/datatable/util';
import { Link } from 'react-router-dom';
import { Tab, Tabs } from 'react-bootstrap';
import Layout from '../../components/layout/Layout';
import RelationDataTable from '../../components/datatable/RelationDataTable';
import EnvelopEditModal from '../../modal/envelop/EnvelopEditModal';
import Alert from '../../modal/alert/Alert';
import { InfoCard } from '../../components/card/InfoCard';
import Card from '../../components/card/Card';

import { FORMATTER_STYLE, getFormatter } from '../../utils/formatter';
import {
  defaultRejectHandler,
  getErrorValue,
  stringifyErrorMessage,
  withDefaultSort,
} from '../../utils/utility';

import {
  clearErrorEnvelop,
  deleteEnvelop,
  getEnvelop,
} from '../../redux/envelop/envelop_actions';

import {
  listSection,
  searchSectionByText,
  addSectionToEnvelop,
  removeSectionFromEnvelop,
  editSectionInEnvelop,
} from '../../redux/section/section_actions';

class EnvelopDetailPage extends React.Component {
  constructor(props) {
    super(props);

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    this.state = {
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isDuplicateModal: false,
    };
  }

  componentDidMount() {
    this.props.getEnvelop(this.props.match.params.envelopId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isEditing && nextProps.isEditing !== this.props.isEditing && !nextProps.errorMessage) {
      this.setState({ isShowEditModal: false });
    }

    if (this.props.isDeleting && nextProps.isDeleting !== this.props.isDeleting && !nextProps.errorMessage) {
      this.props.history.push(`/projects/${this.props.envelopDetail.project_id}`);
    }
  }

  renderActionMenu() {
    const { t } = this.props;
    return [
      <li key="envelop-edit-menu">
        <a
          href="#"
          data-toggle="modal"
          data-target="#edit-envelop"
          onClick={() => this.setState({ isShowEditModal: true })}
        >
          <i className="fas fa-edit" />
          <span className="menu-text">{t('edit envelop')}</span>
        </a>
      </li>,
      <li key="envelop-delete-menu">
        <a
          href="#"
          id="envelop-delete"
          data-toggle="modal"
          data-target="#delete-envelop"
          onClick={() => this.setState({ isShowDeleteModal: true })}
        >
          <i className="fas fa-trash" />
          <span className="menu-text">{t('delete envelop')}</span>
        </a>
      </li>,
    ];
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listSection(
      this.search.pageSize,
      this.search.page,
      withDefaultSort(this.search.sorted),
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
      this.props.envelopDetail.building_id,
    );

    this.setState({ categoryOption: category });
  }

  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }

  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }

  renderEnvelop(envelop) {
    const { isDeleting, errorMessage, t } = this.props;
    const { isShowEditModal, isShowDeleteModal } = this.state;

    const fields = [
      {
        id: 'zone-name',
        label: t('name'),
        value: envelop.zone_name || t('unassigned'),
      },
      {
        id: 'envelop-type',
        label: t('type'),
        value: getFormatter(FORMATTER_STYLE.text)(envelop.type),
      },
      {
        id: 'envelop-azimuth',
        label: t('azimuth angle'),
        value: `${getFormatter(FORMATTER_STYLE.text)(envelop.azimuth_angle)} °`,
      },
      {
        id: 'envelop-inclination',
        label: t('inclination'),
        value: `${getFormatter(FORMATTER_STYLE.text)(envelop.inclination)} °`,
      },
      (
        envelop.type === 'Wall'
          ?
          {
            id: 'envelop-OTTV',
            label: 'OTTV',
            value: envelop.TTV && `${getFormatter(FORMATTER_STYLE.floatFractionDigit2)(envelop.TTV)} ${t('unit_kW')}`,
          }
          :
          {
            id: 'envelop-RTTV',
            label: 'RTTV',
            value: envelop.TTV && `${getFormatter(FORMATTER_STYLE.floatFractionDigit2)(envelop.TTV)} ${t('unit_kW')}`,
          }
      ),
      {
        id: 'envelop-WWR',
        label: t('WWR'),
        value: `${envelop.WWR === null ? '-' : getFormatter(FORMATTER_STYLE.floatFractionDigit2)(envelop.WWR)}`,
      },
      {
        id: 'envelop-description',
        label: t('description'),
        value: envelop.description || '-',
      },
    ];
    return (
      <React.Fragment>
        <h1>{envelop.name}</h1>
        <EnvelopEditModal
          envelop={envelop}
          show={isShowEditModal}
          onHide={() => this.dismissEditModal()}
        />
        <Alert
          show={isShowDeleteModal}
          onHide={() => !isDeleting && this.dismissDeleteModal()}
          title={t('delete section')}
          body={`${t('do you want to delete')} ${envelop ? envelop.name : ''}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={isDeleting ? t('deleting') : t('delete')}
          primaryButtonStyle={'danger'}
          primaryButtonEnabled={!isDeleting}
          onPrimaryButtonClick={() => this.props.deleteEnvelop(envelop)}
        />
        <InfoCard fields={fields} />
      </React.Fragment>
    );
  }

  renderSection(sections) {
    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coefficientColumn = getColumnStyle(COLUMN_STYLE.coefficient);
    const decimalColumn = getColumnStyle(COLUMN_STYLE.decimal);

    const {
      addSectionToEnvelop,
      editSectionInEnvelop,
      removeSectionFromEnvelop,
      isAddingToEnvelop,
      isEditingInEnvelop,
      isRemovingFromEnvelop,
      filteredCount,
      isLoading,
      sectionErrorMessage,
      envelopDetail,
      t,
    } = this.props;

    const columns = [
      {
        id: 'name',
        Header: () => <b>{t('name')}</b>,
        accessor: item => ({ name: item.name, id: item.id }),
        Cell: row => <Link to={`/sections/${row.value.id}`}>{row.value.name}</Link>,
        ...textColumn,
        entity: {
          list: (text, page) => searchSectionByText(text, envelopDetail.building_id, page)
            .then(response => response.data.map(({name, id}) => ({label: name, value: String(id)}))),
        },
      },
      {
        Header: () => <b>{`${t('area')} (${t('sq m')})`}</b>,
        accessor: 'area',
        ...coefficientColumn,
      },
      {
        Header: () => <b>{t('quantity')}</b>,
        accessor: 'quantity',
        ...decimalColumn,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 1 },
        },
      },
      {
        id: 'total_area',
        Header: () => <b>{`${t('total area')} (${t('sq m')})`}</b>,
        accessor: ({ area, quantity }) => area * quantity,
        ...coefficientColumn,
      },
    ];

    const relationship = {
      create: ({ entityId, quantity }) => addSectionToEnvelop(entityId, quantity),
      delete: id => removeSectionFromEnvelop(id),
      edit: ({ id, quantity }) => editSectionInEnvelop(id, quantity),
      isCreating: isAddingToEnvelop,
      isEditing: isEditingInEnvelop,
      isDeleting: isRemovingFromEnvelop,
    };

    return (
      <Card padding={false}>
        <Tabs id="envelop-section-tabs">
          <Tab title={t('sections')} eventKey={1}>
            <RelationDataTable
              columns={columns}
              data={sections}
              errorMessage={stringifyErrorMessage(sectionErrorMessage)}
              relationship={relationship}
              onActionEdit={item => this.setState({ isShowEditModal: true, selectedInstance: item.original })}
              onActionDuplicate={item => this.setState({ isShowDuplicateModal: true, selectedInstance: item.original })}
              onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedInstance: item.original })}
              filteredCount={filteredCount}
              isLoading={isLoading}
              onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
            />
          </Tab>
        </Tabs>
      </Card>
    );
  }

  getBreadcrumb(envelop) {
    if (envelop.is_project_mixed_use) {
      return [
        {
          name: envelop.building_name,
          path: `/buildings/${envelop.building_id}`,
        },
        {
          name: envelop.name,
          path: `/envelops/${envelop.id}`,
        },
      ];
    } else {
      return [
        {
          name: envelop.project_name,
          path: `/projects/${envelop.project_id}`,
        },
        {
          name: envelop.name,
          path: `/envelops/${envelop.id}`,
        },
      ];
    }
  }

  render() {
    const { envelopDetail: envelop, sections } = this.props;

    const breadcrumbItems = envelop ? this.getBreadcrumb(envelop) : [];
    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={breadcrumbItems}
        renderActionMenu={() => this.renderActionMenu()}
      >
        {envelop && this.renderEnvelop(envelop)}
        {envelop && this.renderSection(sections)}
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  envelopDetail: state.envelop.objects[ownProps.match.params.envelopId],
  isEditing: state.envelop.isEditing,
  isDeleting: state.envelop.isDeleting,
  errorMessage: state.envelop.errorMessage,
  sections: state.section.orderedIds.map(id => state.section.objects[id]),
  filteredCount: state.section.filteredCount,
  isLoading: state.section.isLoading,
  isAddingToEnvelop: state.section.isAddingToEnvelop,
  isEditingInEnvelop: state.section.isEditingInEnvelop,
  isRemovingFromEnvelop: state.section.isRemovingFromEnvelop,
  isSectionEditing: state.section.isEditing,
  sectionErrorMessage: state.section.errorMessage,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getEnvelop: id => defaultRejectHandler(dispatch(getEnvelop(id, ownProps.match.params.envelopType))),
  deleteEnvelop: ({ id }) => defaultRejectHandler(dispatch(deleteEnvelop(id))),
  listSection: (pageSize, page, sorted, filtered, isPublic, buildingId) =>
    defaultRejectHandler(dispatch(listSection(pageSize, page, sorted, filtered, isPublic, buildingId, ownProps.match.params.envelopId))),
  addSectionToEnvelop: (id, quantity) => defaultRejectHandler(dispatch(addSectionToEnvelop(id, quantity, ownProps.match.params.envelopId))),
  editSectionInEnvelop: (id, quantity) => defaultRejectHandler(dispatch(editSectionInEnvelop(id, quantity))),
  removeSectionFromEnvelop: id => defaultRejectHandler(dispatch(removeSectionFromEnvelop(id))),
  clearError: () => dispatch(clearErrorEnvelop()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(EnvelopDetailPage),
);



// WEBPACK FOOTER //
// ./src/pages/envelop/EnvelopDetailPage.js